import React, { Suspense } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

// routes
import { useSelector } from 'react-redux';
import Loader from '../Components/Common/Loader';
import StaticFooter from '../Components/Common/StaticFooter';
import StaticNavbar from '../Components/Common/StaticNavbar';
import { getTokenFromStore } from '../utils/Utils';
import { publicRoutes, authProtectedRoutes } from './allRoutes';
import { AuthProtected } from './AuthProtected';
import { SelectSearchValInStore } from '../Store/commonStore/selectors';
import { SelectFullStateOfThisAPI } from '../Store/callAPI/selectors';
import {
    AuthenticationAPI,
    GetRolePermissionsAPI,
    MemberInfoAPI,
    SendOtpAPI,
    VerifyDateOfBirthAPI,
    VerifyOtpAPI
} from '../helpers/APIS/CommonApisSchema';
import { FetchingKey } from '../Store/callAPI/allAPIs';

const Index = () => {
    const isTokenAvailable = useSelector((state) => !!getTokenFromStore(state)?.token);
    const allRolesData = useSelector((state) => SelectSearchValInStore(state, 'allRolesData'));
    const roleAccessData = useSelector((state) => SelectSearchValInStore(state, 'pagePermissions'));
    const SendOtpAPIData = useSelector((state) => SelectFullStateOfThisAPI(state, SendOtpAPI));
    const VerifyOtpAPIData = useSelector((state) => SelectFullStateOfThisAPI(state, VerifyOtpAPI));
    const VerifyDateOfBirthAPIData = useSelector((state) => SelectFullStateOfThisAPI(state, VerifyDateOfBirthAPI));
    const AuthenticationAPIData = useSelector((state) => SelectFullStateOfThisAPI(state, AuthenticationAPI));
    const GetRolePermissionsAPIData = useSelector((state) => SelectFullStateOfThisAPI(state, GetRolePermissionsAPI));
    const MemberInfoAPIData = useSelector((state) => SelectFullStateOfThisAPI(state, MemberInfoAPI));
    const location = useLocation();

    const isSolutionPage = location.pathname.startsWith('/solution');
    const isMemberLoginPage = location.pathname.startsWith('/member-login');

    const isLoading =
        SendOtpAPIData?.[FetchingKey] ||
        VerifyOtpAPIData?.[FetchingKey] ||
        VerifyDateOfBirthAPIData?.[FetchingKey] ||
        AuthenticationAPIData?.[FetchingKey] ||
        GetRolePermissionsAPIData?.[FetchingKey] ||
        MemberInfoAPIData?.[FetchingKey];

    return (
        <React.Fragment>
            {isTokenAvailable && !isSolutionPage && !isMemberLoginPage && !isLoading && <StaticNavbar />}
            <Suspense fallback={<Loader />}>
                <Routes>
                    {/* Public Routes */}
                    {publicRoutes().map((route, idx) => (
                        <Route path={route.path} element={<React.Fragment>{route.component}</React.Fragment>} key={idx + route.path} />
                    ))}

                    {/* Auth Protected Routes */}
                    <Route element={<AuthProtected />}>
                        {authProtectedRoutes(allRolesData, roleAccessData).map((route, idx) => (
                            <Route path={route.path} element={<React.Fragment>{route.component}</React.Fragment>} key={idx + route.path} />
                        ))}
                    </Route>
                </Routes>
            </Suspense>
            {isTokenAvailable && !isSolutionPage && !isMemberLoginPage && !isLoading && <StaticFooter />}
        </React.Fragment>
    );
};

export default Index;
